import { BLUE_DARK } from "@finway-group/shared/lib/consts"
import { Tooltip } from "antd"
import React from "react"
import { Info } from "react-feather"
import { Trans, useTranslation } from "react-i18next"

export const PostingPeriodInfoTooltip = () => {
    const { t } = useTranslation()

    const transComponent = (
        <Trans
            t={t}
            i18nKey="info:posting_period.tooltip"
            components={[<a key="1" href={t("info:posting_period.link")} target="_blank" rel="noreferrer" className="text-white underline" />]}
        />
    )

    return (
        <Tooltip title={transComponent}>
            <Info color={BLUE_DARK} size={14} className="mt-4 ml-4" />
        </Tooltip>
    )
}
